import { P2GDate } from '@parcel2go/core-ui';

import { CollectionDateApiModel } from '~/lib/api/smartsend/types';
import DropList from '../../DropList';

interface props {
  dates: CollectionDateApiModel[];
  selected?: Date;
  setDate: (d: Date) => void;
  variant?: 'body2';
  size: 'small' | 'medium' | 'large';
  limit: number;
  textAlign?: 'left' | 'center' | 'right';
}

export default function ItemCollectionDateView(props: props) {
  if (!props.selected || !props.dates || !props.dates.length) {
    return null;
  }

  return (
    <DropList
      textAlign={props.textAlign}
      selected={[props.selected.toDateString()]}
      items={props.dates
        .slice(0, props.limit)
        .map((x) => new Date(x.Date))
        .map((x) => {
          return {
            value: x.toDateString(),
            text: <P2GDate variant={props.variant} size={props.size} date={x} />
          };
        })}
      onSelect={(x) => props.setDate(new Date(x))}
    />
  );
}
